import { useEffect } from 'react';

import { getLocalStorage, setLocalStorage, StorageKey } from 'src/shared/utils/localStorages';
import { useGoogleTagManager } from 'src/hooks/useGoogleTagManager';

export const AppDataProvider = ({ children }: { children: React.ReactNode }) => {
  // Инициализируем GTM для отслеживания роутов
  useGoogleTagManager();

  useEffect(() => {
    //добавляю userId в LocalStorage на уровне всего приложения
    const userIdLS = getLocalStorage<string>(StorageKey.UserId);
    if (!userIdLS) {
      const generatedUserId = crypto.randomUUID();
      setLocalStorage(StorageKey.UserId, generatedUserId);
    }
  }, []);

  return <>{children}</>;
};
